/* Halloween 2026 — hero: countdown, bats, ghost cursor */
(function () {
  function initHero(root) {
    if (!root || root.dataset.hh2026HeroInit === "1") return;
    root.dataset.hh2026HeroInit = "1";

    var endRaw = (root.getAttribute("data-countdown-end") || "2026-11-01 00:00:00").trim();
    // Theme-style datetime: "2026-11-01 00:00:00" / "2026/11/01 23:59:59" / "... GMT-0800"
    var saleEnd = new Date(endRaw);
    if (isNaN(saleEnd.getTime())) saleEnd = new Date(endRaw.replace(/-/g, "/"));
    if (isNaN(saleEnd.getTime())) saleEnd = new Date(endRaw.replace(" ", "T"));
    var labelDefault = root.getAttribute("data-countdown-label") || "";
    var labelEnded = root.getAttribute("data-countdown-ended") || "THE SALE HAS ENDED";

    function tickCountdown() {
      var diff = saleEnd - new Date();
      var set = function (key, v) {
        var el = root.querySelector('[data-cd="' + key + '"]');
        if (el) el.textContent = String(v).padStart(2, "0");
      };
      var labelEl = root.querySelector("[data-cd-label]");
      if (diff <= 0) {
        set("d", 0);
        set("h", 0);
        set("m", 0);
        set("s", 0);
        if (labelEl) labelEl.textContent = labelEnded;
        return;
      }
      set("d", Math.floor(diff / 86400000));
      set("h", Math.floor(diff / 3600000) % 24);
      set("m", Math.floor(diff / 60000) % 60);
      set("s", Math.floor(diff / 1000) % 60);
      if (labelEl && labelDefault) labelEl.textContent = labelDefault;
    }

    tickCountdown();
    setInterval(tickCountdown, 1000);

    /* Bat sprite animation */
    if (root.getAttribute("data-enable-bats") === "true") {
      var canvas = root.querySelector("[data-bat-canvas]");
      var batSrc = root.getAttribute("data-bat-sprite");
      if (canvas && batSrc) {
        (function () {
          var ctx = canvas.getContext("2d");
          var COLS = 5,
            ROWS = 2,
            TOTAL = 10;
          var SHEET_W = 1983,
            SHEET_H = 620;
          var FW = SHEET_W / COLS;
          var FH = SHEET_H / ROWS;

          var img = new Image();
          img.src = batSrc;

          var bats = [
            { size: 90, speed: 0.9, phase: 0, yBase: 0.18, amp: 55, x: 0, frame: 0, ftick: 0, ftickMax: 5 },
            { size: 65, speed: 1.3, phase: 1.8, yBase: 0.42, amp: 40, x: 0, frame: 3, ftick: 0, ftickMax: 4 },
            { size: 110, speed: 0.7, phase: 0.9, yBase: 0.28, amp: 70, x: 0, frame: 7, ftick: 0, ftickMax: 6 },
            { size: 50, speed: 1.7, phase: 3.2, yBase: 0.6, amp: 30, x: 0, frame: 5, ftick: 0, ftickMax: 3 },
          ];

          function resize() {
            canvas.width = canvas.offsetWidth;
            canvas.height = canvas.offsetHeight;
          }
          resize();
          window.addEventListener("resize", resize);
          bats.forEach(function (b, i) {
            b.x = canvas.width * (0.5 + i * 0.15) + b.size;
          });

          var tick = 0;
          function drawFrame() {
            if (!img.complete) return;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            var cw = canvas.width,
              ch = canvas.height;
            bats.forEach(function (b) {
              b.ftick++;
              if (b.ftick >= b.ftickMax) {
                b.ftick = 0;
                b.frame = (b.frame + 1) % TOTAL;
              }
              b.x -= b.speed;
              if (b.x < -b.size * 1.5) {
                b.x = cw + b.size;
                b.phase = Math.random() * Math.PI * 2;
                b.yBase = 0.1 + Math.random() * 0.65;
              }
              var y = ch * b.yBase + Math.sin(tick * 0.025 + b.phase) * b.amp;
              var col = b.frame % COLS,
                row = Math.floor(b.frame / COLS);
              var half = b.size / 2;
              ctx.save();
              ctx.translate(b.x, y);
              ctx.scale(-1, 1);
              ctx.drawImage(img, col * FW, row * FH, FW, FH, -half, -half, b.size, b.size);
              ctx.restore();
            });
            tick++;
            requestAnimationFrame(drawFrame);
          }
          img.onload = drawFrame;
          if (img.complete) drawFrame();
        })();
      }
    }

    /* Ghost cursor + particle trail — matches reference halloween.html */
    if (root.getAttribute("data-enable-ghost") === "true") {
      var ghostEl = root.querySelector("[data-ghost-cursor]") || document.getElementById("ghost-cursor");
      if (!ghostEl) return;

      if (ghostEl.parentNode !== document.body) {
        document.body.appendChild(ghostEl);
      }
      document.documentElement.classList.add("hh2026-ghost-cursor");
      document.body.classList.add("hh2026-ghost-cursor");

      // Remove prior trail nodes (section reload / double init)
      document.querySelectorAll(".hh2026-ghost-dot, #hh2026-ghost-trail").forEach(function (n) {
        n.remove();
      });

      var MAX_DOTS = 22;
      var dots = [];
      var trail = [];
      var TRAIL_LEN = MAX_DOTS * 3;
      var mx = window.innerWidth / 2;
      var my = window.innerHeight / 2;
      var gx = mx;
      var gy = my;
      var tiltX = 0;
      var tiltY = 0;
      var prevMx = mx;
      var prevMy = my;
      var overClickable = false;

      for (var i = 0; i < MAX_DOTS; i++) {
        var d = document.createElement("div");
        d.className = "hh2026-ghost-dot";
        // Theme base.css has `div:empty{display:none}` — keep a child so dots stay visible
        d.appendChild(document.createElement("span"));
        var age = i / MAX_DOTS;
        var sz = Math.max(2, Math.round(6 - age * 4.5));
        // Inline critical styles so theme CSS cannot hide/flatten particles
        d.style.cssText =
          "position:fixed;left:-9999px;top:-9999px;width:" +
          sz +
          "px;height:" +
          sz +
          "px;margin:0;padding:0;border:0;border-radius:50%;pointer-events:none;z-index:2147482999;" +
          "display:block;transform:translate(-50%,-50%);opacity:0;will-change:left,top,opacity;" +
          "background:radial-gradient(circle,#fff " +
          (30 - age * 20) +
          "%,rgba(180,140,255,.8) 60%,transparent 100%);" +
          "box-shadow:0 0 " +
          sz * 2 +
          "px " +
          sz +
          "px rgba(200,170,255,.5)";
        document.body.appendChild(d);
        dots.push({ el: d });
      }

      var CLICKABLE =
        "a,button,[role='button'],[tabindex]:not([tabindex='-1']),input,select,textarea,label[for],.sku,.sku *,#cat-nav-wrap,#cat-nav-wrap *,.cat-nav-item,.game-card,.cart-icon,modal-opener,add-cart-button";
      /* Hide custom ghost over mini-game modal so play areas use native/crosshair cursors */
      var GHOST_AWAY = "#game-modal-overlay," + CLICKABLE;

      function setAway(away) {
        overClickable = away;
        ghostEl.classList.toggle("hh2026-ghost-away", away);
        document.documentElement.classList.toggle("hh2026-ghost-cursor--pointer", away);
        for (var k = 0; k < dots.length; k++) {
          dots[k].el.classList.toggle("hh2026-ghost-away", away);
        }
      }

      document.addEventListener(
        "mousemove",
        function (e) {
          mx = e.clientX;
          my = e.clientY;
          var hit = e.target && e.target.closest ? e.target.closest(GHOST_AWAY) : null;
          setAway(!!hit);
        },
        { passive: true }
      );

      var frame = 0;
      function tickGhost() {
        requestAnimationFrame(tickGhost);
        frame++;

        gx += (mx - gx) * 0.18;
        gy += (my - gy) * 0.18;

        var vx = mx - prevMx;
        var vy = my - prevMy;
        prevMx = mx;
        prevMy = my;
        tiltX += (vy * 0.4 - tiltX) * 0.12;
        tiltY += (-vx * 0.4 - tiltY) * 0.12;
        var wobble = Math.sin(frame * 0.08) * 3;

        if (!overClickable) {
          ghostEl.style.left = gx + "px";
          ghostEl.style.top = gy + "px";
          ghostEl.style.transform =
            "translate(-50%,-50%) rotate(" +
            (tiltY + wobble) +
            "deg) scaleX(" +
            (1 + Math.min(0.35, Math.abs(vx) * 0.004)) +
            ")";
        }

        // Trail follows raw mouse path (reference behavior)
        trail.unshift({ x: mx, y: my });
        if (trail.length > TRAIL_LEN) trail.length = TRAIL_LEN;

        for (var j = 0; j < MAX_DOTS; j++) {
          var idx = Math.min(j * 3 + 3, Math.max(0, trail.length - 1));
          var t = trail[idx] || { x: mx, y: my };
          var a = j / MAX_DOTS;
          var baseOpacity = overClickable ? 0 : 0.85 - a * 0.8;
          var flicker = 0.7 + 0.3 * Math.sin(frame * 0.15 + j * 0.7);
          dots[j].el.style.left = t.x + "px";
          dots[j].el.style.top = t.y + "px";
          dots[j].el.style.opacity = String(Math.max(0, baseOpacity * flicker));
        }
      }
      tickGhost();
    }
  }

  function boot() {
    document.querySelectorAll("[data-hh2026-hero]").forEach(initHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector("[data-hh2026-hero]");
    if (root) {
      delete root.dataset.hh2026HeroInit;
      initHero(root);
    }
  });
})();
